module.exports = __webpack_public_path__ + "static/media/deal-price-reduction.4186daa1.png";